import { CoparticipationTranslations } from '../models/coparticipation-translaction-model';

// eslint-disable-next-line import/prefer-default-export
export const ptBR: CoparticipationTranslations = {
  title: 'Coparticipação',
  tabs: {
    statement: 'Consulta de Coparticipação',
    reports: 'Meus Relatórios',
  },
  reports: {
    layoutName: 'Relatório de Coparticipação',
  },
  filter: {
    expandSearch: 'Expandir busca',
    collapseSearch: 'Recolher busca',
    clear: 'Limpar filtros',
    search: 'Buscar',
    financialGroup: 'Grupo Financeiro',
    carrier: 'Operadora',
    contract: 'Contrato',
    competence: 'Competência',
    beneficiary: 'Beneficiário',
    copayExempt: 'Coparticipação isenta',
    placeholders: {
      select: 'Selecione',
      competence: 'Selecione a competência',
      beneficiary: 'Informe o beneficiário',
    },
    copayExemptOptions: {
      all: 'Todos',
      yes: 'Sim',
      no: 'Não',
    },
  },
  table: {
    headers: {
      carrier: 'Operadora',
      financialGroup: 'Grupo Financeiro',
      contract: 'Contrato',
      subcontract: 'Subcontrato',
      competence: 'Competência',
      beneficiary: 'Beneficiário',
      ownership: 'Titularidade',
      plan: 'Plano',
      event: 'Evento',
      eventDate: 'Data do evento',
      provider: 'Prestador',
      copayAmount: 'Valor da Coparticipação',
      copayExempt: 'Coparticipação Isenta',
      reason: 'Motivo',
    },
    ownership: {
      holder: 'Titular',
      dependent: 'Dependente',
    },
    yes: 'Sim',
    no: 'Não',
    loading: 'Carregando lançamentos...',
    noData: 'Nenhum lançamento encontrado para os filtros informados.',
    noResult: 'Nenhum resultado encontrado.',
  },
  messages: {
    searchError: 'Erro ao buscar lançamentos de coparticipação.',
    requiredFilters: 'Preencha Operadora, Grupo Financeiro, Contrato e Competência para consultar.',
    exportError: 'Erro ao exportar o relatório de coparticipação.',
    forbiddenAccess: 'Sem permissão para consultar o extrato de coparticipação.',
    noPermission: 'Você não tem permissão para acessar Coparticipação.',
  },
  actions: {
    export: 'Exportar',
  },
};
